<template>
  <qx-card-form title="详情信息">
    <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      originData: {},
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'applyNum',
                label: '申请号码',
              },
              {
                prop: 'openBillAmount',
                label: '开票金额',
              },
              {
                prop: 'createDate',
                label: '申请时间',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        open: {
          label: '开票信息',
          tableData: {
            title: [
              {
                prop: 'invoiceTitle',
                label: '发票抬头',
              },
              {
                prop: 'dutyParagraph',
                label: '税号',
              },
              {
                prop: 'bankName',
                label: '开户银行',
              },
              {
                prop: 'acctNo',
                label: '银行账户',
              },
              {
                prop: 'telPhone',
                label: '联系电话',
              },
              {
                prop: 'registeredAddress',
                label: '注册住所',
              },
              {
                prop: 'mailAddress',
                label: '邮寄地址',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  methods: {
    async sub () {
      return {};
    },
    async cacheData () {
      return this.originData;
    },
    async init (data = {}) {
      this.originData = data;
      data.openBillAmount = data.openBillAmount / 100;
      this.detailData.base.tableData.data = data;
      this.detailData.open.tableData.data = data;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
